import { useState, useEffect } from "react";

interface UseDropdownStateProps {
  defaultValue: string | number;
  onChange: (value: string | number) => void;
  isMobile: boolean;
  setSearchQuery: (query: string) => void;
}

export const useDropdownState = ({
  defaultValue,
  onChange,
  isMobile,
  setSearchQuery,
}: UseDropdownStateProps) => {
  const [open, setOpen] = useState(false);
  const [tempSelectedValue, setTempSelectedValue] = useState<string | number>(
    defaultValue
  );
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    setTempSelectedValue(defaultValue);
  }, [defaultValue]);

  const handleToggle = () => {
    setOpen((prev) => !prev);
    if (!isMobile && defaultValue) {
      setSearchQuery(defaultValue.toString());
    }
    if (isMobile) {
      setTempSelectedValue(defaultValue);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSearchQuery("");
  };

  const handleSelect = (value: string | number) => {
    if (isMobile) {
      setTempSelectedValue(value);
    } else {
      onChange(value);
      handleClose();
    }
  };

  const handleConfirm = () => {
    onChange(tempSelectedValue);
    handleClose();
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    resetHighlightedIndex: () => void
  ) => {
    setSearchQuery(event.target.value);
    resetHighlightedIndex();
    if (!open) {
      setOpen(true);
    }
  };

  return {
    open,
    setOpen,
    tempSelectedValue,
    anchorEl,
    setAnchorEl,
    handleToggle,
    handleClose,
    handleSelect,
    handleConfirm,
    handleInputChange,
  };
};
